import { Record } from "immutable";

export type ContentModuleDraftType<Content, Draft> = {
  id?: string;
  parentId?: string;
  moduleType: string;
  content: Content;
  draft: Draft;
  moduleDifficulty: number;
};

const defaultContentModuleDraft: ContentModuleDraftType<any, any> = {
  id: undefined,
  parentId: undefined,
  moduleType: "unknown",
  content: null,
  draft: null,
  moduleDifficulty: 1
};

export default class ContentModuleDraft extends Record(
  defaultContentModuleDraft
) {}
